import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrCeService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/pr-ces', params);
    }

    store(body: any) {
        return super.post(`/pr-ces`, body);
    }

    edit(prProductId: number) {
        return super.get(`/pr-ces/${prProductId}/edit`);
    }

    update(prProductId: number, body: any) {
        return super.put(`/pr-ces/${prProductId}`, body);
    }

    destroy(prProductId: number) {
        return super.delete(`/pr-ces/${prProductId}`);
    }

    select(params: any = {}) {
        return super.get(`/pr-ces/select`, params);
    }
}
